<template>
<div>
   <br>
<div>
<v-card class="mx-auto profile-card" max-width="1000" elevation="8">
    <!-- Cabeçalho com foto de perfil -->
    <v-card height="160" color="primary" dark flat>
      <v-container>
        <v-row align="center">
          
          <v-col class="profile-title">
            <h1 class="text-h4 font-weight-bold">Meu Perfil</h1>
            
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <!-- Abas de navegação -->
    <v-tabs v-model="tab" grow show-arrows>
      <v-tab>
        <v-icon left>mdi-account-circle</v-icon>
        Informações Pessoais
      </v-tab>
      <v-tab>
        <v-icon left>mdi-account-key</v-icon>
        Dados de Acesso
      </v-tab>
      <v-tab>
        <v-icon left>mdi-account-edit</v-icon>
        Editar Perfil
      </v-tab>
    </v-tabs>

    <!-- Conteúdo das abas -->
    <v-tabs-items v-model="tab">
      <!-- Aba Informações Pessoais -->
      <v-tab-item>
        <v-card flat class="pa-4">
          <v-card-title class="section-title primary--text">
            <v-icon color="primary" left>mdi-information</v-icon>
            Informações Pessoais
          </v-card-title>
          
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr v-for="(item, i) in personalInfo" :key="i">
                    <td width="30%" class="font-weight-bold">{{ item.label }}</td>
                    <td>{{ item.value }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <!-- Aba Dados de Acesso -->
      <v-tab-item>
        <v-card flat class="pa-4">
          <v-card-title class="section-title primary--text">
            <v-icon color="primary" left>mdi-shield-account</v-icon>
            Dados de Acesso
          </v-card-title>
          
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td width="30%" class="font-weight-bold">Nome de usuário</td>
                    <td>{{ usuario.length ? usuario[0].username : '' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Último acesso</td>
                    <td>{{ usuario.length ? formatDate(usuario[0].data_user) : '' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Perfil</td>
                    <td>{{ role }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          
          <v-card-actions>
            <v-btn 
              color="primary" 
              @click="mudarSenha()"
              class="ml-4"
            >
              <v-icon left>mdi-key-change</v-icon>
              Alterar Senha
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>

      <!-- Aba Editar Perfil -->
      <v-tab-item>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card flat class="pa-4">
            <v-card-title class="section-title primary--text">
              <v-icon color="primary" left>mdi-account-edit</v-icon>
              Editar Informações
            </v-card-title>
            
            <v-alert v-if="this.$store.state.textMessage" :type="this.$store.state.classMessage">
              {{ this.$store.state.textMessage }}
            </v-alert>
            
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editedItem.nome"
                    :rules="ruleTextRequired"
                    label="Nome completo"
                    outlined
                    prepend-icon="mdi-account"
                  ></v-text-field>
                </v-col>
                
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editedItem.bilhete"
                    :rules="ruleBI"
                    v-mask="'#########-AA-###'"
                    label="Número do bilhete"
                    outlined
                    prepend-icon="mdi-card-account-details"
                  ></v-text-field>
                </v-col>
              </v-row>
              
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    :rules="ruleRequired"
                    v-model="editedItem.nomepai"
                    label="Nome do pai"
                    outlined
                    prepend-icon="mdi-human-male-boy"
                  ></v-text-field>
                </v-col>
                
                <v-col cols="12" md="6">
                  <v-text-field
                    :rules="ruleRequired"
                    v-model="editedItem.nomemae"
                    label="Nome da mãe"
                    outlined
                    prepend-icon="mdi-human-female-boy"
                  ></v-text-field>
                </v-col>
              </v-row>
              
              <v-text-field
                :rules="ruleRequired"
                v-model="editedItem.contacto"
                label="Contacto telefônico"
                outlined
                prepend-icon="mdi-phone"
                class="mb-4"
              ></v-text-field>
              
              <v-btn 
                color="primary" 
                large 
                @click="Actualizar()" 
                :disabled="!valid"
                :loading="progresso"
              >
                <v-icon left>mdi-content-save</v-icon>
                Salvar Alterações
              </v-btn>
            </v-card-text>
          </v-card>
        </v-form>
      </v-tab-item>
    </v-tabs-items>

    <!-- Modal de Mudança de Senha -->
    <v-dialog v-model="dialogo" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon left color="white">mdi-key-change</v-icon>
          Alteração de Senha
        </v-card-title>

        <v-card-text class="mt-4">
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                type="password"
                :rules="ruleTextRequire"
                v-model="senha_actual"
                label="Senha atual"
                outlined
                prepend-icon="mdi-lock"
              ></v-text-field>
              <v-alert v-if="show_senha_errada" type="error" dense text>
                Senha incorreta
              </v-alert>
            </v-col>
            
            <v-col cols="12">
              <v-text-field
                type="password"
                :rules="[rules.required, rules.password_, rules.password]"
                v-model="senha_nova"
                label="Nova senha"
                outlined
                prepend-icon="mdi-lock-plus"
              ></v-text-field>
            </v-col>
            
            <v-col cols="12">
              <v-text-field
                type="password"
                v-model="senha_confirmar"
                label="Confirmar nova senha"
                outlined
                prepend-icon="mdi-lock-check"
              ></v-text-field>
              <v-alert v-if="error_confirmar" type="error" dense text>
                As senhas não coincidem
              </v-alert>
            </v-col>
          </v-row>
          
          <v-alert v-if="show_mensagem" type="success" dense>
            Senha alterada com sucesso!
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogo = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :disabled="!senha_actual || !senha_confirmar || !senha_nova"
            @click="ContinuarMudarSenha()"
            :loading="progresso"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</div>
</div>
</template>
<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
export default {
  directives: { mask },
  data: () => ({
    photoPerfil: ls.get('urlReport') + 'readFileAnywhere/photoPerfil/' + ls.get('username') + '.jpg',
    usuario: [],
    dialogo: false,
    tab:0,
    senha_actual: '',
    idPessoa: ls.get('idPessoa'),
    image: '',
    valid: true,
    bilhete: '',
    hidePassword: true,
    error_confirmar: false,
    show_senha_errada: false,
    progresso: false,
    senha_nova: '',
    nomemae: '',
    nomepai: '',
    genero: '',
    contacto: '',
    show_mensagem: false,
    usuario_encontrado: [],
    senha_confirmar: '',
    senha: false,

    editedItem: {

      Status: '',
      Usuario_username: '',
      autor: null,
      autorizacoes_nome: '',
      bilhete: '',
      chave_confirmacao: null,
      closed: null,
      contacto: '',
      data_2: '',
      data_func: '',
      data_user: null,
      email: '',
      enable: 0,
      fkPessoa: null,
      fkUsuario: 0,
      foto: '',
      idFuncionario: 0,
      idPEssoa: '',
      idinstituicao: 0,
      idperfilFuncionario: 0,
      idusuario_autorizacao: 0,
      info: null,
      infoNumber: null,
      instituicao: 0,
      instituicaoDescricao: '',
      mudarPassword: '',
      nome: '',
      nomeUsuario: '',
      nomemae: '',
      nomepai: '',
      password: '',
      perfilPessoa: null,
      pkUsuario: 0,
      sessionId: null,
      sexo: '',
      sigla: '',
      status_2: null,
      surv: null,
      telefone: '',
      tema: null,
      uploadedFoto: null,
      username: ''

    },

    defaultItem: {

      Status: '',
      Usuario_username: '',
      autor: null,
      autorizacoes_nome: '',
      bilhete: '',
      chave_confirmacao: null,
      closed: null,
      contacto: '',
      data_2: '',
      data_func: '',
      data_user: null,
      email: '',
      enable: 0,
      fkPessoa: null,
      fkUsuario: 0,
      foto: '',
      idFuncionario: 0,
      idPEssoa: '',
      idinstituicao: 0,
      idperfilFuncionario: 0,
      idusuario_autorizacao: 0,
      info: null,
      infoNumber: null,
      instituicao: 0,
      instituicaoDescricao: '',
      mudarPassword: '',
      nome: '',
      nomeUsuario: '',
      nomemae: '',
      nomepai: '',
      password: '',
      perfilPessoa: null,
      pkUsuario: 0,
      sessionId: null,
      sexo: '',
      sigla: '',
      status_2: null,
      surv: null,
      telefone: '',
      tema: null,
      uploadedFoto: null,
      username: ''

    },

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],

    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    rules: {
      required: value => !!value || 'Required.',
      /* sequential123: value => !value.includes('123') || 'A sequência 123 é invalida.',
      sequentialabc: value => !value.includes('abc') || 'A sequência abc é invalida.', */
      password_: value => value.length >= 8 || 'A password deve ter no minimo 8 caracteres',
      password: value => {
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/
        return (
          pattern.test(value) ||

            'A password deve ter ao menos uma letra maiúscula , minuscula e um número.'
        )
      }
    },
    ruleTextRequire: [
      value => !!value || 'campo obrigatório.'
    ],
    sexo: ['Masculino', 'Femenino']
  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },

    getIdPessoa () {
      return ls.get('idPessoa')
    },

    getRole () {
      return ls.get('role')
    },
    role () {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Sub-Director Pedagógico'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.ObterUsuario()
    // this.$refs.src = 'https://softlineangola.com/files/2727-121212121-SA-12121.jpg'
    // this.image = 'https://softlineangola.com/files/' + this.idPessoa + '.jpg'
    this.image = 'http://restrito.esaudeluanda.com/config/IMS/file/5980-foto.jpg'

    if(this.$store.state.tabPerfil === null)
       this.tab = 0
    else
       this.tab = 1
  },
  methods: {

    logout () {
      ls.remove('token')
      ls.clear()
      this.$router.push('/')
    },

    async ObterUsuario () {
      try {
        this.usuario = await axios
          .get('/PerfilUsuario')
          .then(res => res.data)
        this.editedItem = Object.assign({}, this.usuario[0])
        this.isLoading = false
      } catch (error) {
      }
    },
    mudarSenha () {
      this.dialogo = true
    },

    logout () {
      ls.remove('token')
      ls.clear()
      this.$router.push('/')
    },

    async ContinuarMudarSenha () {
      // Verifica se a senha está correcta
      let dados_1 = {
        password: this.senha_actual
      }

      try {
        this.usuario_encontrado = await axios
          .post('/Verifica-senha/', dados_1)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
      }

      if (this.usuario_encontrado.length) {
        this.show_senha_errada = false

        if (this.senha_nova === this.senha_confirmar) {
          this.progresso = true
          this.error_confirmar = false

          let valor = {

            password: this.senha_nova
          }

          /// Faz a alteraçaõ da senha
          try {
            let msg = await axios
              .post('/altera-senha/', valor)
              .then(res => res.data)
            this.ObterUsuario()
            this.progresso = false
            this.show_mensagem = true
            setTimeout(() => {
              if(this.$store.state.tabPerfil !== null ){this.logout()} // verifica se ele vem do welcome.
              this.dialogo = false
            }, 1000)
            this.Limpar()
          } catch (error) {
            this.progresso = false
          }
        } else { this.error_confirmar = true }
      } else { this.show_senha_errada = true }
    },

    Limpar () {
      this.senha_nova = '',
      this.senha_actual = '',
      this.senha_confirmar = ''
    },

    LimparUpdate (msg) {
      this.bilhete = '',
      this.genero = '',
      this.contacto = '',
      this.nomemae = '',
      this.nomepai = ''
    },

    async Actualizar () {
      this.progresso = true
      const dados =
        {
          nome: this.editedItem.nome,
          bilhete: this.editedItem.bilhete,
          nomepai: this.editedItem.nomepai,
          genero: this.editedItem.sexo,
          nomemae: this.editedItem.nomemae,
          contacto: this.editedItem.contacto
        }

      try {
        let msg = await axios
          .post('/actualizar-funcionario-activo', dados)
          .then(res => res.data)
        this.$store.dispatch('textMessage', { 'msg': 'Dados Pessoais actualizados com sucesso!', 'classMessage': 'msgSucess', 'timeout': 3000 })

        this.progresso = false
        this.LimparUpdate(msg)
        this.ObterUsuario()
      } catch (error) {
        this.progresso = false
      }
    }

  }

}

</script>
